import React, {Component} from 'react';

class Agenda extends Component {
	render() {
		return(
		 <div className="Agenda">
			<h3>Agenda Section</h3><hr/><br/>
			<p>Coming soon!</p>
		 </div>
		)
	}
}

export default Agenda;


// WEBPACK FOOTER //
// ./src/components/Agenda.js